import type { UISlice, UIActions } from '@/types/store';
import type { SliceSet } from './types';

type Slice = UISlice & UIActions;

export const createUISlice = (
  set: SliceSet
): Slice => ({
  activeTab: 'input',
  settingsOpen: false,
  highlightAllergen: null,
  showReviewOnly: false,
  showLoadDemo: true,

  setActiveTab: (tab) => set(() => ({ activeTab: tab })),
  setSettingsOpen: (open) => set(() => ({ settingsOpen: open })),
  setHighlightAllergen: (id) => set(() => ({ highlightAllergen: id })),
  setShowReviewOnly: (show) => set(() => ({ showReviewOnly: show })),
  setShowLoadDemo: (show) => set(() => ({ showLoadDemo: show })),
});
